// extracted by mini-css-extract-plugin
export default {"mainSection":"mainpanel_mainSection__i6QMZ","cardGroup":"mainpanel_cardGroup__nJG9Z","mainPanel":"mainpanel_mainPanel__P4lWf","feedSection":"mainpanel_feedSection__4hBXA"};